import { useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { SnackBarProps } from "./snack-bar.props";

const SnackBar = (props: SnackBarProps) => {
  useEffect(() => {
    if (props.snack) {
      toast(props.snack.message, {
        style: {
          background: props.snack.color ?? "#518c7d",
          color: "white",
          border: "1px solid " + (props.snack.color ?? "white"),
          textAlign: "center",
        },
      });
      props.onRemoveSnack();
    }
  }, [props.snack]);
  return <Toaster />;
};

export { SnackBar };
